export default {"src":"/_next/static/media/frenchfries.91909e69.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};